module.exports = __webpack_public_path__ + "03_glasses_black.0b01f10c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer4/03_glasses_black.png
// module id = wrX4
// module chunks = 0